<template>
  <div>
    <v-app-bar
        outlined
        flat
        color="white"
        height="52px"
        style="border-bottom: 1px solid #EDEDED !important;"
    >
      <IconTooltipButtonBottom
          icon="mdi-arrow-left"
          tooltip="Zurück zur Liste"
          id="default"
          width="50px"
          large
          @click="$router.go(-1)"
      />
      <v-spacer></v-spacer>
      <v-toolbar-title>
        <v-chip outlined color="gray_3" text-color="gray" class="mr-2">{{decodeModuleNameByEnum(survey.module)
          }}</v-chip>
        {{survey.title}}
        <v-chip label :color="parseStateColor(survey.info.state)+'_s'"
                :text-color="parseStateColor(survey.info.state)"
                class="ml-2">{{ parseSurveyState(survey.info.state) }}</v-chip>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <div id="mainFrame">
      <v-row>
        <v-col class="survey-title">
          <h1>Auswertung der Umfrage</h1>
        </v-col>
        <v-col class="d-flex flex-row justify-end">
          <v-card flat class="evaluation-info">
            <v-card-title class="evaluation-info-title">Erstellt am</v-card-title>
            <span class=evaluation-info-text>{{ timeConverter(survey.createdDate) }}</span>
          </v-card>
          <v-card v-if="survey.deadlineDate !== null" flat class="evaluation-info">
            <v-card-title class="evaluation-info-title">Abgeschlossen</v-card-title>
            <span class=evaluation-info-text>{{ timeConverter(survey.deadlineDate)
              }}</span>
          </v-card>
          <v-card flat class="evaluation-info">
            <v-card-title class="evaluation-info-title">Teilnehmeranzahl</v-card-title>
            <span class=evaluation-info-text>{{ survey.info.answeredCount }}</span>
          </v-card>
        </v-col>
      </v-row>
      <v-card outlined class="rounded-lg mb-10 mt-4">
        <div id="surveyVizPanel" class="mt-4 py-2 px-8" />
      </v-card>
    </div>
  </div>
</template>
  
  <script>
  import "survey-analytics/survey.analytics.min.css";
  import { Model } from "survey-core";
  import { VisualizationPanel } from "survey-analytics";
  import pxSurveyService from '../px-survey-service';
  import surveyEvaluationService from '@/components/surveyEvaluationService'
  import IconTooltipButtonBottom from '@/components/common/IconTooltipButtonBottom.vue'
  import {decodeModuleNameByEnum, decodeModuleNameByNumberForEvaluation} from '@/components/util.js'
  
  const vizPanelOptions = {
    allowHideQuestions: false,
    haveCommercialLicense: true
  };
  
  export default {
    components: {
      IconTooltipButtonBottom
    },
    name: "survey-analytics",
    data: () => ({
         surveyId: null,
         survey: null,
         answers: []
      }
    ),
    mounted() {
      if(this.$route.params.surveyId != null){
         this.surveyId = this.$route.params.surveyId;
      }
      if(this.surveyId != null){
         pxSurveyService.retrieveSingleSurvey(this.surveyId).then(res => {
            this.survey = res.data;

            this.survey.schema = JSON.parse(this.survey.schema);
            this.survey.schema.pages.forEach(page => {
               if(page.questions != null){
                page.questions.forEach(q => {
                  if(q.type == "matrix"){
                     q.title = q.rows[0].text;
                  }
               })
               }
            })
            if(this.survey.schema.pages[0].name == "Welcome") this.survey.schema.pages.shift();
            surveyEvaluationService.retrieveAnswersForCustomSurvey(this.surveyId).then(response => {
               response.data.forEach(elem => this.answers.push(JSON.parse(elem.answers)))
               const survey = new Model(this.survey.schema);
               const vizPanel = new VisualizationPanel(
               survey.getAllQuestions(),
               this.answers,
               vizPanelOptions
               );
               vizPanel.showHeader = true;
               vizPanel.render(document.getElementById("surveyVizPanel"));
            })
         });
      }
      
    },
    methods: {
      decodeModuleNameByNumberForEvaluation:decodeModuleNameByNumberForEvaluation,
      decodeModuleNameByEnum: decodeModuleNameByEnum,
      parseSurveyState(state){
        switch(state){
          case "ANSWERED":
            return "Beantwortet";
          case "SEND":
            return "Versendet";
          case "FINISHED":
            return "Beendet";
          case "CREATED":
            return "Erstellt";
        }
      },
      parseStateColor(state){
        switch(state){
          case "ANSWERED":
            return "violet";
          case "SEND":
            return "lightblue";
          case "FINISHED":
            return "lightgreen";
          case "CREATED":
            return "gray";
        }
      },
      timeConverter(timestamp) {
        if(timestamp == null) return " - ";
        let dt = new Date(timestamp);
        let months = ['Jan','Feb','Mär','Apr','Mai','Jun','Jul','Aug','Sep','Oct','Nov','Dez'];
        let year = dt.getFullYear();
        let month = months[dt.getMonth()];
        let date = dt.getDate();
        let time = month + ' ' + date + '. ' + year;
        return time
      },
    }
  };
  </script>
  <style scoped>
  .evaluation-info {
    padding: 12px 8px;
    min-width: 166px;
    margin-left: 10px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.04));
  }
  .evaluation-info-title {
    font-size: 12px;
    color: var(--gray-color_3);
    font-weight: 400;
    margin: 0;
    padding: 0;
  }
  .evaluation-info-text {
    font-size: 16px;
    color: var(--motiverse-secondary);
    font-weight: 600;
    margin: 0;
    padding: 0;
    float: right;
  }
  </style>